<template>
  <b-layout :colors="$site.colors" :notice="false">
    <div v-if="page">
      <section
        v-if="page.showTitle"
        :style="{
          color: page.titleColour || '#000000'
        }"
        class="mb-16 relative rounded-b overflow-hidden max-w-7xl mx-auto"
        :class="[
          hero ? '-mt-16 sm:-mt-40 pt-60 pb-44' : 'pt-16'
        ]"
      >
        <img v-if="hero" :src="hero" alt="" class="absolute inset-0 h-full w-full object-cover" @error="handleHeroError">
        <div v-if="hero" class="absolute inset-0 h-full w-full bg-header/[var(--bookapp-opacity-hero)]" />
        <b-container class="relative z-10">
          <div class="w-full flex flex-col items-center justify-center">
            <div
              class=" text-center text-secondary"
              :class="[
                hero ? 'mb-14' : ''
              ]"
            >
              <h1
                class="text-6xl font-semibold mb-2"
                :style="{
                  color: page.titleColour || '#000000'
                }"
              >
                {{ page.title }}
              </h1>

              <p
                :style="{
                  color: page.titleColour || '#000000'
                }"
                class="opacity-80"
              >
                {{ page.info }}
              </p>
            </div>
          </div>
        </b-container>
      </section>

      <section>
        <b-container>
          <div class="max-w-6xl mx-auto text-secondary">
            <client-only>
              <PagesRender :data="page.content" />
            </client-only>
          </div>
        </b-container>
      </section>
    </div>
  </b-layout> 
</template>

<script setup lang="ts">
const { $api } = useNuxtApp()
const route = useRoute()

const slug = computed(() => route.params.slug)

const { data, refresh } = await useAsyncData(
  slug.value,
  () => $api.location.customPage({ slug: slug.value })
)

const title = computed(() => data.value?.title)
const page = computed(() => data.value?.customPage)

const hero = ref<string | null>(null)

watch(page, (value) => {
  const imageUrls = value?.hero?.imageUrls
  hero.value = imageUrls?.xlarge ?? imageUrls?.large ?? null
}, { immediate: true })

const handleHeroError = () => {
  const large = page.value?.hero?.imageUrls?.large
  hero.value = hero.value !== large ? large ?? null : null
}

useSeoMeta({
  title: () => title.value,
  ogTitle: () => title.value,
  description: () => data.value?.info,
  ogDescription: () => data.value?.info,
})
</script>
